import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormatColorText } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from "framer-motion";
import { MARKS, DEFAULT_COLOR, COLOR_OPTIONS } from '../../../constants';
import PopupWrapper from '../../PopupWrapper';

class FontColor extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.colorClick = this.colorClick.bind(this);
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  colorClick(event) {
    event.preventDefault();
    const color = event.currentTarget.dataset.color;

    // first find all font color marks on the selected text and remove them
    this.props.value.marks.forEach(mark => {
      const currentMarkcolor = mark.data.get('color');
      this.props.editor.removeMark({
        type: MARKS.FONT_COLOR,
        data: { color: currentMarkcolor },
      });
    });

    // then add the new incoming font color mark
    if (color !== DEFAULT_COLOR) {
      this.props.editor.addMark({ type: MARKS.FONT_COLOR, data: { color } });
    }

    this.togglePopup();
  }

  render() {
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--fontcolor">
          <button
            title="Text Color"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <FormatColorText />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
            <motion.div
              initial={{ opacity: 0, y: '80%' }}
              animate={{ opacity: 1, y: '100%' }}
              exit={{ opacity: 0, y: '80%' }}
              transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
              className="icon__popup icon__popup--fontcolor">
              <button
                onClick={this.colorClick}
                data-color={DEFAULT_COLOR}
                className="default-color border-0 cursor-pointer flex items-center justify-between mb-5 p-0 text-sm mb-5 outline-none">
                <span>Default</span>{' '}
                <span style={{ backgroundColor: DEFAULT_COLOR }} />
              </button>
              <div className="color-group flex flex-wrap">
                {COLOR_OPTIONS.map(color => {
                  return (
                    <button
                      title={color}
                      className="outline-none cursor-pointer"
                      onClick={this.colorClick}
                      data-color={color}
                      key={color}
                      style={{ backgroundColor: color }}
                    />
                  );
                })}
              </div>
            </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  FontColor;
